import React, { Component } from "react";
import { inject, observer } from "mobx-react";
import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider from 'react-bootstrap-table2-toolkit';
import InfiniteScroll from "react-infinite-scroll-component";
import { Row, Col, Container } from 'reactstrap';

import LoadingImage from "../../comum/components/LoadingImage";
import Footer from "../../comum/components/Footer";
import FooterContent from "../../comum/components/FooterContent";
import { HeaderTableFixed } from "../../../utils/headerTableFixed";

@inject("store")
@observer
export class TabelaLogs extends Component {

    constructor(props) {
        super(props);
        this.controller = this.props.controller;


        window.addEventListener('scroll', HeaderTableFixed);
    }
    renderDados = () => {
        let loading = this.controller.loading;
        // let itens = [{
        //     LogId: 1,
        //     Usuario: 'WSTSCC',
        //     Data: new Date().getDate(),
        //     Campo: "Email",
        //     ValorAnterior: "anterior",
        //     ValorAtual: "    ",
        //     Operacao: "INCLUIR",
        // }, {
        //     LogId: 2,
        //     Usuario: 'WSTSCC',
        //     Data: 'new Date()',
        //     Campo: "Email",
        //     ValorAnterior: "anterior",
        //     ValorAtual: "    ",
        //     Operacao: "INCLUIR",
        // }]
        return (
            <Container fluid className="tabela-container">
                {(!this.controller.filtrado)
                    ?
                    <Row>
                        <Col className="mt-3" xs={12}>
                            <span className="mensagem-filtrar">
                                {"No data"}
                            </span>
                        </Col>
                    </Row>
                    :
                    <InfiniteScroll
                        dataLength={this.controller.itens.length}
                        next={() => this.controller.loadNextTurn()}
                        hasMore={this.controller.hasMore}
                        loader={<LoadingImage />}
                    >
                        <ToolkitProvider
                            keyField="LogId"
                            data={[...this.controller.itens]}
                            columns={[...this.controller.colunas]}
                        >
                            {props => (
                                <div>
                                    <div id="tableHeaderFixed" className="tabela-overflow">
                                        <BootstrapTable
                                            bootstrap4
                                            striped
                                            bordered={false}
                                            noDataIndication={() => loading ?
                                                <LoadingImage /> : "Nenhum registro encontrado."}
                                            classes="tabela tabela-layout agendamento"
                                            {...props.baseProps}
                                        />
                                    </div>

                                </div>)
                            }
                        </ToolkitProvider>
                    </InfiniteScroll>
                }
                <Footer>
                    <FooterContent>
                        {this.controller.total !== null && <div className="justify-content-between">
                            <div><b>{this.controller.itens.length}</b> Registros no Total - <a
                                onClick={() => this.controller.carregarLista()}>Atualizar Lista</a>
                            </div>
                        </div>}
                    </FooterContent>

                </Footer>

            </Container>
        );
    }

    render() {
        return <React.Fragment>
            {this.renderDados()}
        </React.Fragment>
    }
}


// WEBPACK FOOTER //
// ./src/modules/atualizacaocadastral/components/TabelaLogs.js